import { Reveal, SectionHeading } from "@/components/motion";

const CHAPTERS = [
  {
    n: "01",
    title: "Ingestion Layer",
    body: "You send us coordinates, timestamps, route IDs, ETA windows, expected arrival polygons, device telemetry, and driver claims. Any routing engine, any format.",
    meta: "POST /api/event/ingest",
  },
  {
    n: "02",
    title: "Statics Collection",
    body: "Your operational rules, geofences, compliance windows, proximity curves, and truth parameters — versioned per tenant, applied deterministically.",
    meta: "RULESETS · GEOFENCES · THRESHOLDS",
  },
  {
    n: "03",
    title: "Truth Engine",
    body: "GeoVerify compares expected vs actual, planned vs observed, claimed vs verified, device vs driver, routing vs reality. Four deltas, one verdict.",
    meta: "POST /api/event/verify",
  },
  {
    n: "04",
    title: "Compliance & Audit Output",
    body: "We return truth status, compliance flags, anomaly signals, and an immutable audit trail you can hand to insurers, regulators, and internal teams.",
    meta: "GET /api/event/audit",
  },
];

const HowItWorks = () => (
  <section id="how-it-works" data-testid="how-it-works" className="border-b border-border bg-muted/30">
    <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-24 lg:py-32">
      <SectionHeading
        index="05"
        eyebrow="How GeoVerify Works"
        title="Intentionally simple. Rigorously verified."
      />
      <p className="mt-6 text-base md:text-lg text-muted-foreground max-w-2xl">
        It ingests your events, applies your rules, and returns truth, compliance, and anomaly
        signals you can trust.
      </p>
      <div className="mt-20">
        {CHAPTERS.map((c, i) => (
          <Reveal key={c.n} delay={i * 0.08}>
            <div
              data-testid={`chapter-${c.n}`}
              className="group grid lg:grid-cols-12 gap-6 items-start border-t border-border py-12 lg:py-16"
            >
              <div className="lg:col-span-4">
                <span className="font-display font-black tracking-tight text-7xl lg:text-[7rem] leading-none text-foreground/10 group-hover:text-telemetry transition-colors duration-500">
                  {c.n}
                </span>
              </div>
              <div className="lg:col-span-5">
                <h3 className="font-display font-extrabold tracking-tight text-3xl lg:text-4xl">{c.title}</h3>
                <p className="text-base text-muted-foreground leading-relaxed mt-4 max-w-lg">{c.body}</p>
              </div>
              <div className="lg:col-span-3 lg:pt-3">
                <span className="font-mono text-[11px] tracking-[0.2em] uppercase border border-border px-3 py-2 inline-block text-muted-foreground">
                  {c.meta}
                </span>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default HowItWorks;
